export default "__VITE_ASSET__KCL5nKfP__"